/*

? First, let's import the interface that will describe the shape of our chat object.

*/

import StateInterface from "../state-interface";

/*

& Now let's describe an initial state for the chat object. This is the state that will be used when the app first fires up. Think of it like a placeholder.

*/

export const chat: StateInterface["chat"] = {
	_id: "",
	chat_type: "",
	chat_title: "",
	chat_description: "",
	chat_dp: {
		file_id: "",
		original_file_server_path: "",
	},
	participants: [],
	admins: [],
	last_message: {
		body: "",
		sender_is_business_profile: false,
		sender_user_id: "",
		sender_business_profile_id: "",
		sent_at: "",
	},
	notification_settings: [],
	created_by: {
		is_business_profile: false,
		user_id: "",
		business_profile_id: "",
	},
	unread_messages_count: [],
	created_at: "",
	is_vanish_mode: false,
	vanish_at: "",
	trigger_vanish_at: "",
	updated_at: "",
	deleted_for: [],
	is_broadcast: false,
	broadcast_id: "",
};
